/* eslint camelcase: 0 */
import { Agency } from '@/infrastructure/network/Monitaro/schema/models'
import { IAgencyProps, EmptyAgencyPropsFactory } from '@/entities/Agency'

export const toAgencyProps = (props: Agency | null | undefined): IAgencyProps => {
  if (!props) {
    return EmptyAgencyPropsFactory()
  }

  const { id, name, kana, properties, created_at, updated_at } = props

  return EmptyAgencyPropsFactory({
    id,
    name,
    kana,
    properties,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
